module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Loan extension","period":"Extension period, days","fee":"Extension fee"},"et":{"title":"Loan extension","period":"Extension period, days","fee":"Extension fee"},"ru":{"title":"Loan extension","period":"Extension period, days","fee":"Extension fee"}}')
  delete Component.options._Ctor
}
